import { Button } from '@components/ui';
import styled from 'styled-components';

export const ChevronButtonSC = styled(Button)`
  grid-area: btn;
`;
